var map = {
	"./arrow-down-right.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/arrow-down-right.svg",
	"./arrow-down.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/arrow-down.svg",
	"./arrow-hook-left.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/arrow-hook-left.svg",
	"./arrow-left.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/arrow-left.svg",
	"./arrow-right.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/arrow-right.svg",
	"./arrow-up.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/arrow-up.svg",
	"./bell.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/bell.svg",
	"./caret-down.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/caret-down.svg",
	"./caret-left.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/caret-left.svg",
	"./caret-right.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/caret-right.svg",
	"./caret-up.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/caret-up.svg",
	"./check.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/check.svg",
	"./cloud-slash.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/cloud-slash.svg",
	"./confused-face.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/confused-face.svg",
	"./copy.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/copy.svg",
	"./envelope.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/envelope.svg",
	"./external.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/external.svg",
	"./feed.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/feed.svg",
	"./heart.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/heart.svg",
	"./link.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/link.svg",
	"./magnifying-glass.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/magnifying-glass.svg",
	"./paperclip.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/paperclip.svg",
	"./pencil.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/pencil.svg",
	"./plus.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/plus.svg",
	"./speech-balloon.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/speech-balloon.svg",
	"./x.svg": "./node_modules/@svgr/webpack/lib/index.js!./src/assets/icons/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync ./!./!./node_modules/@svgr/webpack/lib/index.js!./ \\.svg$";